import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import EmptyModal from "../../components/modals/EmptyModal";
import Button from "../../components/ui/Button";
import ActionLink from "../../components/controls/ActionLink";
import OperationalDataTableSkeleton from "../../components/operational/OperationalDataTableSkeleton";
import { CreditReturnsViewModel } from "../../viewmodels/shipping/CreditReturnsViewModel";
import { withRouter, formatDate } from "../../shared/utility";

const tableSkeletonColumns = [
  "Return #",
  "Customer",
  "Type",
  "Credit Type",
  "Status",
  "Items",
  "Created",
  "Actions",
];

function CreditReturns(props) {
  const { logout, addSnackbar } = props;
  const searchRef = useRef();
  const { creditReturns, loading, getCreditReturns, emptyModal, setEmptyModelOpen } = CreditReturnsViewModel(logout, addSnackbar);

  useEffect(() => {
    getCreditReturns(null, 1);
  }, []);

  const actionsBody = (rowData) => (
    <ActionLink to={`/credit-returns/${rowData.id}`} variant="primary">
      View
    </ActionLink>
  );

  return (
    <div className="qatrace-screen qatrace-module-page">
      <div className="space-y-5 px-4 sm:px-6 lg:px-8">
        <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <nav aria-label="Breadcrumb">
            <ol className="flex flex-wrap items-center gap-2 text-xs font-medium sm:text-sm">
              <li><Link to="/credit-returns" className="text-[#16A34A] transition hover:text-[#15803D]">Returns / Credits</Link></li>
              <li className="text-[#CBD5E1]" aria-hidden="true">/</li>
              <li className="text-[#475569]">Manage</li>
            </ol>
          </nav>
          <Button type="button" variant="primary" size="md" onClick={() => (window.location = "/credit-returns/new")}>Create Return</Button>
        </header>

        <div className="overflow-visible rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          <div className="border-b border-[#E2E8F0] p-4">
            <input
              type="search"
              ref={searchRef}
              onKeyDown={(e) => e.key === "Enter" && getCreditReturns(e.target.value, 1)}
              className="block min-h-10 w-full rounded-xl border border-[#E2E8F0] bg-white py-2 px-3 text-sm text-[#0F172A] shadow-sm placeholder:text-[#94A3B8] focus:border-[#16A34A] focus:outline-none focus:ring-2 focus:ring-[#BBF7D0]"
              placeholder="Search by return # or customer..."
            />
          </div>
          <div className="operational-embedded-table overflow-hidden">
            {loading ? (
              <OperationalDataTableSkeleton
                columns={tableSkeletonColumns}
                rows={10}
              />
            ) : (
              <DataTable
                value={creditReturns.data ?? []}
                dataKey="id"
                className="p-datatable-sm text-sm"
                emptyMessage="No returns found."
              >
                <Column field="credit_return_number" header="Return #" style={{ minWidth: "10rem" }} />
                <Column field="customer_name" header="Customer" style={{ minWidth: "12rem" }} />
                <Column field="return_type" header="Type" style={{ minWidth: "9rem" }} />
                <Column field="credit_type" header="Credit Type" style={{ minWidth: "9rem" }} />
                <Column field="status" header="Status" style={{ minWidth: "8rem" }} />
                <Column field="items_count" header="Items" style={{ minWidth: "6rem" }} />
                <Column header="Created" body={(row) => formatDate(row.created_at)} style={{ minWidth: "10rem" }} />
                <Column header="Actions" body={actionsBody} style={{ minWidth: "8rem" }} />
              </DataTable>
            )}
          </div>
        </div>
      </div>
      <EmptyModal childComponent={emptyModal.childComponent} open={emptyModal.open} setOpen={setEmptyModelOpen} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({ logout: () => dispatch(actions.logout()), addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)) });
export default withRouter(connect(null, mapDispatchToProps)(CreditReturns));
